const taskTypeToLinkRelation = {
  'personality.assessment': '/personality-assessment',
  'interests.profile': '/interests-profiler',
  'tuition.search': '/tuition',
  'scholarships.search': '/scholarships',
  'careers.search': '/jobs',
  'resumes.education.search': '/search?searchType=education',
  'resumes.career.search': '/search?searchType=career',
}

const mapTaskTypeToLink = taskType => taskType && `/app${taskTypeToLinkRelation[taskType]}`

export default {
  mapTaskTypeToLink,
}



// WEBPACK FOOTER //
// ./src/utils/routing/taskLinks.js